<div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
        <span class="badge badge-warning badge-circle icon-bordered-warning">
            <i class="fa-regular fa-triangle-exclamation text-warning"></i>
        </span>
        <h4 class="title">Unsaved Changes Alert</h4>
        <p>You have unsaved changes</p>
        <button color="error" class="close" [mat-dialog-close] (click)="dialogRef.close(true)">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
        <p>Would you like to stay and save the changes or discard the changes without saving?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
        <button mat-button mat-stroked-button class="button-medium" color="dark" [mat-dialog-close]
            (click)="dialogRef.close(true)">Don't Save</button>
        <button mat-button mat-flat-button class="button-medium" color="primary" [mat-dialog-close]
            (click)="dialogRef.close(false)">Stay and Save</button>
    </div>
</div>


